<template>
  <div
    class="w-full rounded-lg overflow-hidden relative text-white vote-result"
  >
    <div class="w-full flex">
      <div
        v-for="(category, i) of categories"
        :key="i"
        :style="{
          width: `${category.percentage}%`,
          height: '3.5rem',
          'background-color': category.background
        }"
      ></div>
    </div>
    <div class="w-full absolute top-0 left-0 flex">
      <div
        v-for="(category, i) of categories"
        class="vote"
        :key="i"
        :style="{
          flex: `1 ${100 - parseInt(category.percentage)} ${
            category.percentage
          }%`,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          height: '3.5rem'
        }"
      >
        <span
          v-if="showLabel(i)"
          class="flex flex-col leading-tight"
          style="z-index:+1;"
        >
          <span class="text-chplus-xs uppercase">{{ category.label }}</span>
          <!-- chplus-regular bold -->
          <span class="text-chplus-regular text-bold leading-none">
            {{ category.percentage.toFixed(1)
            }}<span class="vote-result-percent">%</span>
          </span>
          <div
            class="text-chplus-xs whitespace-no-wrap"
            v-html="$tc('views.government.vote.vote_count', category.count)"
          ></div>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "VoteResult",
  props: {
    result: {
      type: Object,
      required: true
    }
  },
  computed: {
    categories() {
      const totalPerPercent =
        (this.result.yes.percentage +
          this.result.other.percentage +
          this.result.no.percentage) /
        100;
      return [
        {
          label: this.$t("views.government.vote.yes_vote"),
          count: this.result.yes.count,
          percentage: this.result.yes.percentage / totalPerPercent,
          background: "#7FB59F"
        },
        {
          label: this.$t("views.government.vote.other_vote"),
          count: this.result.other.count,
          percentage: this.result.other.percentage / totalPerPercent,
          background: "var(--interaction-dark)"
        },
        {
          label: this.$t("views.government.vote.no_vote"),
          count: this.result.no.count,
          percentage: this.result.no.percentage / totalPerPercent,
          background: "#7A7A7A"
        }
      ].filter(category => category.percentage > 0);
    }
  },
  methods: {
    showLabel(i) {
      const isFirstOrLast = i === 0 || i === this.categories.length - 1;
      return (
        isFirstOrLast ||
        Math.max(
          Math.min(
            this.categories[i - 1].percentage,
            this.categories[i + 1].percentage
          ),
          this.categories[i].percentage
        ) > 16
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.vote {
  transition: width ease-in-out 600ms;
  text-align: center;
}

.vote-result .vote:first-child {
  text-align: left;
  margin-left: 0.75rem;
}

.vote-result .vote:last-child {
  text-align: right;
  margin-right: 0.75rem;
}

.vote .vote-result-percent {
  font-size: 0.8rem;
  vertical-align: top;
}
</style>
